import type { Country, CountryDetailsDto } from "../services/CountriesService";
import type { LanguageCode } from "../state/i18n";

const EU_ACRONYM = "EU";

export const isEuCountry = (country: CountryDetailsDto): boolean =>
  country.regionalBlocs?.some(({ acronym }) => acronym === EU_ACRONYM) ?? false;

export const getCountryName = (country: Country, language: LanguageCode): string =>
  country.translations[language] ?? country.name;
